import React from 'react'
import styles from './hero.module.css'
import heroQuotes from '../quote-carousel/quotes.json';
import HeroCtaSection2 from './hero-cta-section-2';
import HeroLogos from './hero-logos';
import Quote from '../quote-carousel/quote';
import EyebrowAnimated from '../eybrow-animated/eybrow-animated';
import HeroFeatured from './hero-featured';
import SmartLink from '../common/smart-link';

const Head1 = () => (<h2>Your Evidence-Based Playbook for Women&rsquo;s Health</h2>);
// const Head2 = () => (<h2>The Answers You've Been Searching For</h2>);

const eyebrowPhrases = [
  "3 Years of Reporting.",
  "132 Female Experts.",
  "Science-Backed.",
];

export default function Hero() {
  const handleBookImageClick = () => {
    try {
      window.analytics?.trackEvent('hero_book_image_click', {
        destination: 'order_header',
        link_type: 'book_image',
      });
    } catch { }
  };

  return (
    <section id="hero" className={`hero ${styles.hero}`}>
      <div className={styles.container}>
        <div className={styles.heroContent}>
          <div className={styles.heroHead}>
            <Head1 />
            <EyebrowAnimated
              phrases={eyebrowPhrases}
              subhead="The New Standard in Women&rsquo;s Health."
              colorOdd="var(--color-primary)"
              colorEven="var(--color-primary)"
              colorSubhead="var(--color-link)"
            />

          </div>
          <div className={styles.heroImage}>
            <SmartLink
              href="#order-header"
              className={styles.heroImageLink}
              onLinkClick={handleBookImageClick}
              aria-label="Go to order section"
            >
              <div className={styles.imageWrapper}>
                <img src="assets/images/book-3d.png" alt="The New Rules of Women&rsquo;s Health Book" className={styles.bookImage} />
                <HeroFeatured />
              </div>
            </SmartLink>
          </div>
          <div className={styles.heroBody}>
            <div className={styles.heroQuoteDesktop}>
              <Quote quote={heroQuotes[0]} />
            </div>

            <HeroCtaSection2 />
            {/* <HeroCtaSectionHorizontal /> */}
          </div>
        </div>

        <div className={styles.heroQuoteMobile}>
          <Quote quote={heroQuotes[0]} />
        </div>

      </div>

      <HeroLogos />
    </section>
  )
}
